import { render, staticRenderFns } from "./AIChatbotIframeError.vue?vue&type=template&id=a174a8ae"
import script from "./AIChatbotIframeError.vue?vue&type=script&lang=js"
export * from "./AIChatbotIframeError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports